/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type { Criticality } from './Criticality';
import type { IncidentDatasetDto } from './IncidentDatasetDto';
import type { IncidentTeamDto } from './IncidentTeamDto';
import type { UserDto } from './UserDto';

export type IncidentCatalogAssetDto = {
    assignees: Array<UserDto>;
    compromisedAssets: number;
    criticality: Criticality;
    datasets: Array<IncidentDatasetDto>;
    id: string;
    issueNo: number;
    lastOccurredDate: number;
    name: string;
    qualification?: IncidentCatalogAssetDto.qualification;
    status: IncidentCatalogAssetDto.status;
    teams: Array<IncidentTeamDto>;
    triggerTime: number;
};

export namespace IncidentCatalogAssetDto {

    export enum qualification {
        FIXED = 'FIXED',
        FALSE_POSITIVE = 'FALSE_POSITIVE',
        NO_ACTION_NEEDED = 'NO_ACTION_NEEDED',
        DUPLICATE = 'DUPLICATE',
        AUTOMATIC = 'AUTOMATIC',
    }

    export enum status {
        OPEN = 'OPEN',
        IN_PROGRESS = 'IN_PROGRESS',
        CLOSED = 'CLOSED',
    }


}
